import { RichTextBlock } from 'prismic-reactjs';
import gql from 'graphql-tag';
import { IEmbed, IImage, ILink } from 'utils/types';
import { IBaseSlice, SliceTypes } from '..';
import { PrismicEmbed, PrismicImage, PrismicLink } from '../../utils/PrismicTypes';
import { parser } from '../../utils/parsers';

export interface IImageBlock extends IBaseSlice {
  title: string;
  text: RichTextBlock[];
  globe: string;
  image: IImage;
  caption: string;
  direction: string;
  link: ILink;
  buttonText: string;
  buttonNumber: string;
  buttonSubline: string;
  buttonLabel: string;
  buttonCaption: string;
  video: ILink;
  embed: IEmbed;
  items: Array<{
    label: string;
    link: ILink;
  }>;
}

export const fragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_title
        slice_text
        slice_globe
        slice_image
        slice_caption
        slice_direction
        slice_link { ...Link }
        slice_buttontext
        slice_buttonnumber
        slice_buttonsubline
        slice_buttonlabel
        slice_buttoncaption
        slice_video { ...Link }
        slice_embed
      }
      fields {
        item_label
        item_link { ...Link }
      }
    }
  }
`;

type Props = {
  primary: {
    slice_title: RichTextBlock[];
    slice_text: RichTextBlock[];
    slice_globe: string;
    slice_image: PrismicImage;
    slice_caption: RichTextBlock[];
    slice_direction: string;
    slice_link: PrismicLink;
    slice_buttontext: RichTextBlock[];
    slice_buttonnumber: RichTextBlock[];
    slice_buttonlabel: RichTextBlock[];
    slice_buttoncaption: RichTextBlock[];
    slice_buttonsubline: RichTextBlock[];
    slice_video: PrismicLink;
    slice_embed: PrismicEmbed;
  };
  fields: Array<{
    item_label: RichTextBlock[];
    item_link: PrismicLink;
  }>;
};

export const parse = (slice: Props, redirects): IImageBlock => ({
  type: SliceTypes.ImageBlock,
  title: parser.string(slice.primary.slice_title),
  text: parser.richText(slice.primary.slice_text, redirects),
  globe: parser.string(slice.primary.slice_globe),
  image: parser.image(slice.primary.slice_image),
  caption: parser.string(slice.primary.slice_caption),
  direction: parser.string(slice.primary.slice_direction),
  link: parser.link(slice.primary.slice_link, redirects),
  buttonText: parser.string(slice.primary.slice_buttontext),
  buttonNumber: parser.string(slice.primary.slice_buttonnumber),
  buttonLabel: parser.string(slice.primary.slice_buttonlabel),
  buttonCaption: parser.string(slice.primary.slice_buttoncaption),
  buttonSubline: parser.string(slice.primary.slice_buttonsubline),
  video: parser.link(slice.primary.slice_video),
  embed: parser.embed(slice.primary.slice_embed),
  items: slice.fields
    ?.map((field) => ({
      label: parser.string(field.item_label),
      link: parser.link(field.item_link, redirects),
    }))
    .filter((f) => f.label && f.link),
});
